export const ChangePositionTraspasos = {
  idPartner: -99,
  idPosition: -99,
  idBranch: -99,
  reason: "",
};
